import { Navigate } from 'react-router-dom'

import { useHomeUrl } from 'hooks/useHomeUrl'

export const NavigateToHome = () => {
  const homeUrl = useHomeUrl()

  return <Navigate replace to={homeUrl} />
}
